import React from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

function AutoCompleteFieldThreejs({ field, form, label, options = [], onValueChange, onClear, isRequired, ...props }) {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
    const sortedOptions = React.useMemo(() => {
        const seen = new Set();
        return [...options]
       .sort((a, b) => (a?.label || "").localeCompare(b?.label || ""))
            .filter(option => {
                if (seen.has(option?.id)) return false;
                seen.add(option?.id);
                return true;
            });
    }, [options]);

    return (
        <FormControl fullWidth error={!!errorText}>
            {field.name && (
                <InputLabel sx={{ ml: -1.6, textTransform: "capitalize" }} shrink htmlFor={field.name} >
                    <Typography variant="h6">
                        {label}
                        {isRequired && (
                            <Typography variant="h5" color="error" component="span">
                                {" *"}
                            </Typography>
                        )}
                    </Typography>
                </InputLabel>
            )}
            <Autocomplete
             disableClearable
                {...props}
                id={field.name}
                filterOptions={(opts, { inputValue }) =>
                    opts?.filter(option => option?.label?.toLowerCase()?.includes(inputValue.toLowerCase()))
                }
                noOptionsText={<Typography variant="h6">{props.noOptionsText || "No Option"}</Typography>}
                options={sortedOptions}
                value={sortedOptions.find((option) => option.value === field.value) ?? null}
                sx={{
                    backgroundColor: "#F7FAFF",
                    border: "1px solid #4169E1",
                    borderRadius: "5px",
                    mt: 2,
                    "& fieldset": { border: "none" },
                    "& .MuiOutlinedInput-root .MuiAutocomplete-input": { padding: "0", height: "25px", textTransform: "capitalize" },
                    "& .MuiInputBase-input": { fontSize: "12px", textTransform: "capitalize" },
                    "& .MuiInputBase-input.Mui-disabled": {
                        color: "#4d4d4d",
                        WebkitTextFillColor: "#4d4d4d",
                    }
                }}
                onChange={(_, value) => {
                    if (value === null) {
                        form.setFieldValue(field.name, "");
                        onClear?.();
                    }
                    if (value) {
                        form.setFieldValue(field.name, value.value);
                        onValueChange?.(value);
                    }
                }}

                renderOption={(props, option) => (
                    <li {...props} key={option.value}>
                        <Typography variant="h6" sx={{ textTransform: "capitalize" }}>{option.label}</Typography>
                    </li>
                )}
                renderInput={(params) => (
                    <TextField
                        placeholder={label ? `${label}` : "Select"}
                        // error={Boolean(errorText)}
                        // helperText={errorText}
                        label={undefined}
                        name={field.name}
                        {...params}
                    />
                )}
                onInputChange={(_, newValue, reason) => {
                    if (reason === "input") {
                        props.onSearchChange?.(newValue);
                    }
                }}
            // value={options.find((option) => option.value === field.value) ?? null}
            />
            {errorText && <Typography variant="h6" fontSize={"10px"} color="red">{errorText}</Typography>}
        </FormControl>
    );
}

export { AutoCompleteFieldThreejs };
